import React from 'react';

const Loading = (props) =>
{
  const className = (() => {
    let array = [];
    if (!!props.fullscreen) array.push('fullscreen');
    if (!!props.small) array.push('small');
    return array;
  })().join(' ');

  return <div id="loading" className={className}><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div>;
}

export default Loading;